module.exports = __webpack_public_path__ + "static/media/instagram_round.3423397d.svg";